import {Injectable} from '@angular/core';
import {MapInterface} from '../../models/GenericModel';


@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  private filterMap: MapInterface;

  constructor() {
    this.filterMap = {};
  }

  storeElement(name: string, value: any): void {
    this.filterMap[name] = value;
  }

  getStoredElement(name: string): any {
    return this.filterMap[name];
  }
}


